let homePageUrl = '';
let homePageUrlKsy = '';
let baseUrl = '';
let serverUrl = '';
let shareUrl = '';
switch (process.env.NODE_ENV) {
  case 'production':
    homePageUrl = 'https://www.ipunique.com/'; // production
    homePageUrlKsy = 'https://www.cjtglobal.com/'; // productionKsy
    baseUrl = 'https://admin.cjtglobal.com/api/cjt';
    serverUrl = 'https://sc-rec.gstarsea.com/sa?project=production';
    shareUrl = 'https://cjtglobal.com/';
    // wgUrl='https://www.chenhaiip.com/client/'
    wgUrl = 'https://cjtglobal.com/client/';
    baseIframeUrl = 'https://new-admin.cjtglobal.com';
    break;
  case 'testing':
    homePageUrl = 'http://ipunique.cjton-dev.business.xy/'; // testing
    homePageUrlKsy = 'https://www.cjtglobal.com/'; // testingKsy
    baseUrl = 'http://admin.cjton-dev.business.xy/api/cjt';
    serverUrl = 'https://sc-rec.gstarsea.com/sa?project=default';
    shareUrl = 'https://www.cjtglobal.com';
    wgUrl = 'https://www.cjtglobal.com/client/';
    baseIframeUrl = 'http://new-admin.cjton-dev.business.xy';
    break;
  case 'development':
    homePageUrl = 'https://www.cjtglobal.com/'; // development
    homePageUrlKsy = 'https://www.cjtglobal.com/'; // testingKsy
    baseUrl = 'http://172.20.17.46:8080';
    serverUrl = 'https://sc-rec.gstarsea.com/sa?project=default';
    shareUrl = 'https://www.cjtglobal.com';
    wgUrl = 'https://www.cjtglobal.com/client/';
    break;
}
// 活动时间
const activeTempTimes = {
  start: '2022/09/6 9:00:00',
  end: '2022/09/8 23:59:59',
};
/**
 * 根据活动时间判断是否进行活动
 * @returns {boolean}
 */
const activeRange = () => {
  let now = new Date().getTime();
  let start = new Date(activeTempTimes.start).getTime();
  let end = new Date(activeTempTimes.end).getTime();
  if (now < start || now > end) {
    return false;
  } else {
    return true;
  }
};
module.exports = {
  /**
   *  api请求基础路径
   */
  apiUrl: {
    // dev: "https://pre-api.cjton.com", //  本地环境接口请求n地址
    dev: 'https://admin.cjtglobal.com/api/cjt', //  本地环境接口请求n地址
    // pro: "https://pre-api.cjton.com", //  预发布打包请求地址
    // test环境
    pro: 'https://admin.cjtglobal.com/api/cjt', //  测试接口请求地址
    server_url: serverUrl,
    shareUrl: shareUrl, // h5地址预发布
    homePageUrl: homePageUrl, // 首页地址
    homePageUrlKsy: homePageUrlKsy, // 首页地址Ksy
    wgUrl: wgUrl, // 外观首页地址
    baseUrl: baseUrl,
    baseIframeUrl: baseIframeUrl, //iframeUrl 链接地址
    // sim环境
    // pro:"https://sim-xcloud-api.cjton.com" ,
    // shareUrl: "https://sim-xcloud-iipto-h5.cjton.com/", //sim环境
    // homePageUrl: "https://sim-xcloud-iipto-seo.cjton.com/" //预发布首页地址

    // 线上环境！！！
    // pro: 'https://api.cjton.com', //  生产环境打包请求地址
    // shareUrl: 'https://m.cjton.com/',//H5地址线上
    // homePageUrl: 'https://www.cjton.com/', //线上首页地址
    // server_url: "https://sc-rec.gstarsea.com/sa?project=production",
  },
  /**
   * 设置全局活动时间
   */
  activeTempTimes: {
    start: activeTempTimes.start,
    end: activeTempTimes.end,
    isTrue: activeRange(),
  },
  enterpriseCode: {
    dev: 'pn4pn456jy1', // 本地环境
    pro: 'pn4pn456jy1', // 测试环境
  },
};



// WEBPACK FOOTER //
// ./src/config/index.js